
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as more11CIHhmwoNbU4tg2cT4Yayp0TyM7xq0rq6AXigvfWXkMeta } from "/opt/atlassian/pipelines/agent/build/pages/more.vue?macro=true";
import { default as pricingqgnaBxRjYRM0YMhM_45by91FQSJ9AkxJy8_4PT1w8vzb0Meta } from "/opt/atlassian/pipelines/agent/build/pages/pricing.vue?macro=true";
import { default as dashboardjCm8x0vIO2JRC6YkJLYIbDyBSQi5nyAEb_8t_45C91IjMMeta } from "/opt/atlassian/pipelines/agent/build/pages/dashboard.vue?macro=true";
import { default as loginmqChTMOYPI_45MOz8kWJVZzbGcd_4541XZ_N20dtMEWeq5sMeta } from "/opt/atlassian/pipelines/agent/build/pages/auth/login.vue?macro=true";
import { default as signupZczg3vgVd4mgrE8H1xYHaMg7sIPrx13VhpHCaSGvzpQMeta } from "/opt/atlassian/pipelines/agent/build/pages/auth/signup.vue?macro=true";
import { default as indexZB5KB_452B48WtB8ECBVUCrNeF73_45Ntg5e2nnwOcx4iYcMeta } from "/opt/atlassian/pipelines/agent/build/pages/groups/index.vue?macro=true";
import { default as complete34BQBpcsZFHK9_45fQMiLJozsThQGp_Vp8PvdbM4XoE9AMeta } from "/opt/atlassian/pipelines/agent/build/pages/auth/complete.vue?macro=true";
import { default as indexUtVn6fmANOukde4aCuekX5Nlzs7H3BnYwzdefEyMaT8Meta } from "/opt/atlassian/pipelines/agent/build/pages/courses/index.vue?macro=true";
import { default as about_45yournFJ1wHN_45qyZ1eUvIkkq_opma9H_45vMdQUtrlTJGlBzUMeta } from "/opt/atlassian/pipelines/agent/build/pages/auth/about-you.vue?macro=true";
import { default as index6QmFz6BzzCZIId9W_45Gm4voMqTdfckcnrcQ_cnx3cXbMMeta } from "/opt/atlassian/pipelines/agent/build/pages/webinars/index.vue?macro=true";
import { default as thank_45youDWW_45VawGi4zr4wpPTW9ql1eb6CRUZPIx96rGj_45aasV8Meta } from "/opt/atlassian/pipelines/agent/build/pages/enroll/thank-you.vue?macro=true";
import { default as verify_45emailGDTCqBvwZITKZoRD4mExwHB1v9HRKjkiBs2CPjamhEIMeta } from "/opt/atlassian/pipelines/agent/build/pages/auth/verify-email.vue?macro=true";
import { default as summaryIZxcjVf45nttpuHopgYvFpOT_45ZMFmC5n7NCiyZIYlyEMeta } from "/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/summary.vue?macro=true";
import { default as comparison1o5M_wlah3lqVd_45AOJAPYepiUJYJiIcwrYcj6AJyJnUMeta } from "/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/comparison.vue?macro=true";
import { default as recommendationso7kqWT1OuHcF2p6pENHP0RXmv7DVOfhMhd5SdgTlGjoMeta } from "/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/recommendations.vue?macro=true";
import { default as _91quizId_93AZC3iOzzN701DGSSkvEwyC36UAFK_45MgwA_45HSnByUEaYMeta } from "/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/quizzes/[quizId].vue?macro=true";
import { default as _91lessonId_93Cz_zeF0fq53I35d4J9fASj3BOelUmRq5xYm07o5NgOQMeta } from "/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/lessons/[lessonId].vue?macro=true";
import { default as _91courseId_9327kx8Ms_p0RYoJlZBXRVcLeyxvcqnRDoWRuHrqaf6_sMeta } from "/opt/atlassian/pipelines/agent/build/pages/courses/[courseId].vue?macro=true";
import { default as _91planGroup_93Xg9gLKqif9uLXCJPwGw5mop81eEpkblm9INwlY_45CT5UMeta } from "/opt/atlassian/pipelines/agent/build/pages/enroll/[planGroup].vue?macro=true";
import { default as _91webinar_93FyGtdF6s64fYg1FxO80CDsq37sA4fQLQWcnO1jna6wwMeta } from "/opt/atlassian/pipelines/agent/build/pages/webinars/[webinar].vue?macro=true";
import { default as reset_45passwordIVT45OWVwrv2GiQVutwfzPq59yDh_45MSUk_o09yowPY8Meta } from "/opt/atlassian/pipelines/agent/build/pages/auth/reset-password.vue?macro=true";
import { default as profile_45infoCinV3OhOYxzKFJZpC_45w5evc2Chf3mXIl0KG3n6CFR5sMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/profile-info.vue?macro=true";
import { default as subscriptionpBUVCgGZaDNN8SDWvtwOBg0sM9qeoZU9YxEE7zdSg68Meta } from "/opt/atlassian/pipelines/agent/build/pages/account/subscription.vue?macro=true";
import { default as forgot_45passwordsIIB_sBTbGRj_45qjr50O1gxcqIcCzfXRuKDvM4Cg5GpEMeta } from "/opt/atlassian/pipelines/agent/build/pages/auth/forgot-password.vue?macro=true";
import { default as welcome_45aboardhPljeOYidBlFr_eaKDHATH9oruGE_45L8hhJA790BfytAMeta } from "/opt/atlassian/pipelines/agent/build/pages/enroll/welcome-aboard.vue?macro=true";
import { default as app_45authenticatedm2ESAgFmscrpt8kNdGRXGSzWhPb4KJ7ZTPTg1sLMG_45oMeta } from "/opt/atlassian/pipelines/agent/build/pages/auth/app-authenticated.vue?macro=true";
import { default as _91planGroup_936kIfZcquxPsHs2QFwCWzPUqYSZFiTWgXPio9xl8EPTkMeta } from "/opt/atlassian/pipelines/agent/build/pages/enroll/new/[planGroup].vue?macro=true";
import { default as ai_45prompting_45tool_YTaLy21yU1s3bczqvc6f9ffVVThSvfI3ustDemTHpsMeta } from "/opt/atlassian/pipelines/agent/build/pages/tools/ai-prompting-tool.vue?macro=true";
import { default as professional_45info89PKhYZoFvYjQ6sOUgmN9tzh_45dpEyFSRSCuYLv_45CuG0Meta } from "/opt/atlassian/pipelines/agent/build/pages/account/professional-info.vue?macro=true";
import { default as _91memberId_93go8Ja8T6IFSRPT0tTQJtlKciPagkU3sjyLdcRGN5c40Meta } from "/opt/atlassian/pipelines/agent/build/pages/groups/members/[memberId].vue?macro=true";
import { default as deletion_45cancelledhQPHqJLL3rPn_Tc_P7Sk6ceXWTzAI2Z2ijXLklRwTOwMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/deletion-cancelled.vue?macro=true";
import { default as deletion_45scheduled0Ya_Y7XQ_C2QiZ1_45WufcUk40HkkIVrU_wpg4oOzCVDEMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/deletion-scheduled.vue?macro=true";
import { default as confirm_45deletion_45codecuI3wuJq6TOq5iaKhR4Xmu_7mq7jHYTvQihEceWUMy0Meta } from "/opt/atlassian/pipelines/agent/build/pages/account/confirm-deletion-code.vue?macro=true";
import { default as accept2zAguSGtR9ZHnywUGTQDIF7BJbbcwttZlzlnIR7EKNIMeta } from "/opt/atlassian/pipelines/agent/build/pages/groups/[groupId]/invite/accept.vue?macro=true";
export default [
  {
    name: "more___en",
    path: "/more",
    meta: more11CIHhmwoNbU4tg2cT4Yayp0TyM7xq0rq6AXigvfWXkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/more.vue")
  },
  {
    name: "more___de",
    path: "/de/more",
    meta: more11CIHhmwoNbU4tg2cT4Yayp0TyM7xq0rq6AXigvfWXkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/more.vue")
  },
  {
    name: "more___fr",
    path: "/fr/more",
    meta: more11CIHhmwoNbU4tg2cT4Yayp0TyM7xq0rq6AXigvfWXkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/more.vue")
  },
  {
    name: "more___es",
    path: "/es/more",
    meta: more11CIHhmwoNbU4tg2cT4Yayp0TyM7xq0rq6AXigvfWXkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/more.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    meta: pricingqgnaBxRjYRM0YMhM_45by91FQSJ9AkxJy8_4PT1w8vzb0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/pricing.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardjCm8x0vIO2JRC6YkJLYIbDyBSQi5nyAEb_8t_45C91IjMMeta || {},
    alias: ["/"],
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/dashboard.vue")
  },
  {
    name: "auth-login___en",
    path: "/auth/login",
    meta: loginmqChTMOYPI_45MOz8kWJVZzbGcd_4541XZ_N20dtMEWeq5sMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/login.vue")
  },
  {
    name: "auth-login___de",
    path: "/de/auth/login",
    meta: loginmqChTMOYPI_45MOz8kWJVZzbGcd_4541XZ_N20dtMEWeq5sMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/login.vue")
  },
  {
    name: "auth-login___fr",
    path: "/fr/auth/login",
    meta: loginmqChTMOYPI_45MOz8kWJVZzbGcd_4541XZ_N20dtMEWeq5sMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/login.vue")
  },
  {
    name: "auth-login___es",
    path: "/es/auth/login",
    meta: loginmqChTMOYPI_45MOz8kWJVZzbGcd_4541XZ_N20dtMEWeq5sMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/login.vue")
  },
  {
    name: "auth-signup___en",
    path: "/auth/signup",
    meta: signupZczg3vgVd4mgrE8H1xYHaMg7sIPrx13VhpHCaSGvzpQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/signup.vue")
  },
  {
    name: "auth-signup___de",
    path: "/de/auth/signup",
    meta: signupZczg3vgVd4mgrE8H1xYHaMg7sIPrx13VhpHCaSGvzpQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/signup.vue")
  },
  {
    name: "auth-signup___fr",
    path: "/fr/auth/signup",
    meta: signupZczg3vgVd4mgrE8H1xYHaMg7sIPrx13VhpHCaSGvzpQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/signup.vue")
  },
  {
    name: "auth-signup___es",
    path: "/es/auth/signup",
    meta: signupZczg3vgVd4mgrE8H1xYHaMg7sIPrx13VhpHCaSGvzpQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/signup.vue")
  },
  {
    name: "groups___en",
    path: "/groups",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/groups/index.vue")
  },
  {
    name: "groups___de",
    path: "/de/groups",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/groups/index.vue")
  },
  {
    name: "groups___fr",
    path: "/fr/groups",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/groups/index.vue")
  },
  {
    name: "groups___es",
    path: "/es/groups",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/groups/index.vue")
  },
  {
    name: "auth-complete___en",
    path: "/auth/complete",
    meta: complete34BQBpcsZFHK9_45fQMiLJozsThQGp_Vp8PvdbM4XoE9AMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/complete.vue")
  },
  {
    name: "auth-complete___de",
    path: "/de/auth/complete",
    meta: complete34BQBpcsZFHK9_45fQMiLJozsThQGp_Vp8PvdbM4XoE9AMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/complete.vue")
  },
  {
    name: "auth-complete___fr",
    path: "/fr/auth/complete",
    meta: complete34BQBpcsZFHK9_45fQMiLJozsThQGp_Vp8PvdbM4XoE9AMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/complete.vue")
  },
  {
    name: "auth-complete___es",
    path: "/es/auth/complete",
    meta: complete34BQBpcsZFHK9_45fQMiLJozsThQGp_Vp8PvdbM4XoE9AMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/complete.vue")
  },
  {
    name: "courses",
    path: "/courses",
    meta: indexUtVn6fmANOukde4aCuekX5Nlzs7H3BnYwzdefEyMaT8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/index.vue")
  },
  {
    name: "auth-about-you",
    path: "/auth/about-you",
    meta: about_45yournFJ1wHN_45qyZ1eUvIkkq_opma9H_45vMdQUtrlTJGlBzUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/about-you.vue")
  },
  {
    name: "webinars",
    path: "/webinars",
    meta: index6QmFz6BzzCZIId9W_45Gm4voMqTdfckcnrcQ_cnx3cXbMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/webinars/index.vue")
  },
  {
    name: "thank-you",
    path: "/enroll/thank-you",
    meta: thank_45youDWW_45VawGi4zr4wpPTW9ql1eb6CRUZPIx96rGj_45aasV8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/enroll/thank-you.vue")
  },
  {
    name: "auth-verify-email___en",
    path: "/auth/verify-email",
    meta: verify_45emailGDTCqBvwZITKZoRD4mExwHB1v9HRKjkiBs2CPjamhEIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___de",
    path: "/de/auth/verify-email",
    meta: verify_45emailGDTCqBvwZITKZoRD4mExwHB1v9HRKjkiBs2CPjamhEIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___fr",
    path: "/fr/auth/verify-email",
    meta: verify_45emailGDTCqBvwZITKZoRD4mExwHB1v9HRKjkiBs2CPjamhEIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___es",
    path: "/es/auth/verify-email",
    meta: verify_45emailGDTCqBvwZITKZoRD4mExwHB1v9HRKjkiBs2CPjamhEIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/verify-email.vue")
  },
  {
    name: "course___en",
    path: "/courses/:courseId()",
    meta: { ...(_91courseId_9327kx8Ms_p0RYoJlZBXRVcLeyxvcqnRDoWRuHrqaf6_sMeta || {}), ...{"middleware":"course-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId].vue"),
    children: [
  {
    name: "summary___en",
    path: "summary",
    meta: { ...(summaryIZxcjVf45nttpuHopgYvFpOT_45ZMFmC5n7NCiyZIYlyEMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/summary.vue")
  },
  {
    name: "comparison___en",
    path: "comparison",
    meta: { ...(comparison1o5M_wlah3lqVd_45AOJAPYepiUJYJiIcwrYcj6AJyJnUMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/comparison.vue")
  },
  {
    name: "recommendations___en",
    path: "recommendations",
    meta: { ...(recommendationso7kqWT1OuHcF2p6pENHP0RXmv7DVOfhMhd5SdgTlGjoMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/recommendations.vue")
  },
  {
    name: "quiz___en",
    path: "quizzes/:quizId()",
    meta: { ...(_91quizId_93AZC3iOzzN701DGSSkvEwyC36UAFK_45MgwA_45HSnByUEaYMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/quizzes/[quizId].vue")
  },
  {
    name: "lesson___en",
    path: "lessons/:lessonId()",
    meta: { ...(_91lessonId_93Cz_zeF0fq53I35d4J9fASj3BOelUmRq5xYm07o5NgOQMeta || {}), ...{"middleware":["course-activity-access-middleware"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/lessons/[lessonId].vue")
  }
]
  },
  {
    name: "course___de",
    path: "/de/courses/:courseId()",
    meta: { ...(_91courseId_9327kx8Ms_p0RYoJlZBXRVcLeyxvcqnRDoWRuHrqaf6_sMeta || {}), ...{"middleware":"course-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId].vue"),
    children: [
  {
    name: "summary___de",
    path: "summary",
    meta: { ...(summaryIZxcjVf45nttpuHopgYvFpOT_45ZMFmC5n7NCiyZIYlyEMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/summary.vue")
  },
  {
    name: "comparison___de",
    path: "comparison",
    meta: { ...(comparison1o5M_wlah3lqVd_45AOJAPYepiUJYJiIcwrYcj6AJyJnUMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/comparison.vue")
  },
  {
    name: "recommendations___de",
    path: "recommendations",
    meta: { ...(recommendationso7kqWT1OuHcF2p6pENHP0RXmv7DVOfhMhd5SdgTlGjoMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/recommendations.vue")
  },
  {
    name: "quiz___de",
    path: "quizzes/:quizId()",
    meta: { ...(_91quizId_93AZC3iOzzN701DGSSkvEwyC36UAFK_45MgwA_45HSnByUEaYMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/quizzes/[quizId].vue")
  },
  {
    name: "lesson___de",
    path: "lessons/:lessonId()",
    meta: { ...(_91lessonId_93Cz_zeF0fq53I35d4J9fASj3BOelUmRq5xYm07o5NgOQMeta || {}), ...{"middleware":["course-activity-access-middleware"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/lessons/[lessonId].vue")
  }
]
  },
  {
    name: "course___fr",
    path: "/fr/courses/:courseId()",
    meta: { ...(_91courseId_9327kx8Ms_p0RYoJlZBXRVcLeyxvcqnRDoWRuHrqaf6_sMeta || {}), ...{"middleware":"course-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId].vue"),
    children: [
  {
    name: "summary___fr",
    path: "summary",
    meta: { ...(summaryIZxcjVf45nttpuHopgYvFpOT_45ZMFmC5n7NCiyZIYlyEMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/summary.vue")
  },
  {
    name: "comparison___fr",
    path: "comparison",
    meta: { ...(comparison1o5M_wlah3lqVd_45AOJAPYepiUJYJiIcwrYcj6AJyJnUMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/comparison.vue")
  },
  {
    name: "recommendations___fr",
    path: "recommendations",
    meta: { ...(recommendationso7kqWT1OuHcF2p6pENHP0RXmv7DVOfhMhd5SdgTlGjoMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/recommendations.vue")
  },
  {
    name: "quiz___fr",
    path: "quizzes/:quizId()",
    meta: { ...(_91quizId_93AZC3iOzzN701DGSSkvEwyC36UAFK_45MgwA_45HSnByUEaYMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/quizzes/[quizId].vue")
  },
  {
    name: "lesson___fr",
    path: "lessons/:lessonId()",
    meta: { ...(_91lessonId_93Cz_zeF0fq53I35d4J9fASj3BOelUmRq5xYm07o5NgOQMeta || {}), ...{"middleware":["course-activity-access-middleware"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/lessons/[lessonId].vue")
  }
]
  },
  {
    name: "course___es",
    path: "/es/courses/:courseId()",
    meta: { ...(_91courseId_9327kx8Ms_p0RYoJlZBXRVcLeyxvcqnRDoWRuHrqaf6_sMeta || {}), ...{"middleware":"course-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId].vue"),
    children: [
  {
    name: "summary___es",
    path: "summary",
    meta: { ...(summaryIZxcjVf45nttpuHopgYvFpOT_45ZMFmC5n7NCiyZIYlyEMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/summary.vue")
  },
  {
    name: "comparison___es",
    path: "comparison",
    meta: { ...(comparison1o5M_wlah3lqVd_45AOJAPYepiUJYJiIcwrYcj6AJyJnUMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/comparison.vue")
  },
  {
    name: "recommendations___es",
    path: "recommendations",
    meta: { ...(recommendationso7kqWT1OuHcF2p6pENHP0RXmv7DVOfhMhd5SdgTlGjoMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/recommendations.vue")
  },
  {
    name: "quiz___es",
    path: "quizzes/:quizId()",
    meta: { ...(_91quizId_93AZC3iOzzN701DGSSkvEwyC36UAFK_45MgwA_45HSnByUEaYMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/quizzes/[quizId].vue")
  },
  {
    name: "lesson___es",
    path: "lessons/:lessonId()",
    meta: { ...(_91lessonId_93Cz_zeF0fq53I35d4J9fASj3BOelUmRq5xYm07o5NgOQMeta || {}), ...{"middleware":["course-activity-access-middleware"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/courses/[courseId]/lessons/[lessonId].vue")
  }
]
  },
  {
    name: "enroll",
    path: "/enroll/:planGroup()",
    meta: _91planGroup_93Xg9gLKqif9uLXCJPwGw5mop81eEpkblm9INwlY_45CT5UMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/enroll/[planGroup].vue")
  },
  {
    name: "webinars-webinar",
    path: "/webinars/:webinar()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/webinars/[webinar].vue")
  },
  {
    name: "auth-reset-password___en",
    path: "/auth/reset-password",
    meta: reset_45passwordIVT45OWVwrv2GiQVutwfzPq59yDh_45MSUk_o09yowPY8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___de",
    path: "/de/auth/reset-password",
    meta: reset_45passwordIVT45OWVwrv2GiQVutwfzPq59yDh_45MSUk_o09yowPY8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___fr",
    path: "/fr/auth/reset-password",
    meta: reset_45passwordIVT45OWVwrv2GiQVutwfzPq59yDh_45MSUk_o09yowPY8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___es",
    path: "/es/auth/reset-password",
    meta: reset_45passwordIVT45OWVwrv2GiQVutwfzPq59yDh_45MSUk_o09yowPY8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/reset-password.vue")
  },
  {
    name: "account-profile-info",
    path: "/account/profile-info",
    meta: profile_45infoCinV3OhOYxzKFJZpC_45w5evc2Chf3mXIl0KG3n6CFR5sMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/profile-info.vue")
  },
  {
    name: "account-subscription",
    path: "/account/subscription",
    meta: subscriptionpBUVCgGZaDNN8SDWvtwOBg0sM9qeoZU9YxEE7zdSg68Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/subscription.vue")
  },
  {
    name: "auth-forgot-password___en",
    path: "/auth/forgot-password",
    meta: forgot_45passwordsIIB_sBTbGRj_45qjr50O1gxcqIcCzfXRuKDvM4Cg5GpEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-password___de",
    path: "/de/auth/forgot-password",
    meta: forgot_45passwordsIIB_sBTbGRj_45qjr50O1gxcqIcCzfXRuKDvM4Cg5GpEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-password___fr",
    path: "/fr/auth/forgot-password",
    meta: forgot_45passwordsIIB_sBTbGRj_45qjr50O1gxcqIcCzfXRuKDvM4Cg5GpEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-password___es",
    path: "/es/auth/forgot-password",
    meta: forgot_45passwordsIIB_sBTbGRj_45qjr50O1gxcqIcCzfXRuKDvM4Cg5GpEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/forgot-password.vue")
  },
  {
    name: "welcome-aboard___en",
    path: "/enroll/welcome-aboard",
    meta: welcome_45aboardhPljeOYidBlFr_eaKDHATH9oruGE_45L8hhJA790BfytAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/enroll/welcome-aboard.vue")
  },
  {
    name: "welcome-aboard___de",
    path: "/de/enroll/welcome-aboard",
    meta: welcome_45aboardhPljeOYidBlFr_eaKDHATH9oruGE_45L8hhJA790BfytAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/enroll/welcome-aboard.vue")
  },
  {
    name: "welcome-aboard___fr",
    path: "/fr/enroll/welcome-aboard",
    meta: welcome_45aboardhPljeOYidBlFr_eaKDHATH9oruGE_45L8hhJA790BfytAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/enroll/welcome-aboard.vue")
  },
  {
    name: "welcome-aboard___es",
    path: "/es/enroll/welcome-aboard",
    meta: welcome_45aboardhPljeOYidBlFr_eaKDHATH9oruGE_45L8hhJA790BfytAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/enroll/welcome-aboard.vue")
  },
  {
    name: "auth-app-authenticated___en",
    path: "/auth/app-authenticated",
    meta: app_45authenticatedm2ESAgFmscrpt8kNdGRXGSzWhPb4KJ7ZTPTg1sLMG_45oMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/app-authenticated.vue")
  },
  {
    name: "auth-app-authenticated___de",
    path: "/de/auth/app-authenticated",
    meta: app_45authenticatedm2ESAgFmscrpt8kNdGRXGSzWhPb4KJ7ZTPTg1sLMG_45oMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/app-authenticated.vue")
  },
  {
    name: "auth-app-authenticated___fr",
    path: "/fr/auth/app-authenticated",
    meta: app_45authenticatedm2ESAgFmscrpt8kNdGRXGSzWhPb4KJ7ZTPTg1sLMG_45oMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/app-authenticated.vue")
  },
  {
    name: "auth-app-authenticated___es",
    path: "/es/auth/app-authenticated",
    meta: app_45authenticatedm2ESAgFmscrpt8kNdGRXGSzWhPb4KJ7ZTPTg1sLMG_45oMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/auth/app-authenticated.vue")
  },
  {
    name: "enroll-new",
    path: "/enroll/new/:planGroup()",
    meta: _91planGroup_936kIfZcquxPsHs2QFwCWzPUqYSZFiTWgXPio9xl8EPTkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/enroll/new/[planGroup].vue")
  },
  {
    name: "tools-ai-prompting-tool",
    path: "/tools/ai-prompting-tool",
    meta: ai_45prompting_45tool_YTaLy21yU1s3bczqvc6f9ffVVThSvfI3ustDemTHpsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/tools/ai-prompting-tool.vue")
  },
  {
    name: "account-professional-info",
    path: "/account/professional-info",
    meta: professional_45info89PKhYZoFvYjQ6sOUgmN9tzh_45dpEyFSRSCuYLv_45CuG0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/professional-info.vue")
  },
  {
    name: "groups-members-memberId___en",
    path: "/groups/members/:memberId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/groups/members/[memberId].vue")
  },
  {
    name: "groups-members-memberId___de",
    path: "/de/groups/members/:memberId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/groups/members/[memberId].vue")
  },
  {
    name: "groups-members-memberId___fr",
    path: "/fr/groups/members/:memberId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/groups/members/[memberId].vue")
  },
  {
    name: "groups-members-memberId___es",
    path: "/es/groups/members/:memberId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/groups/members/[memberId].vue")
  },
  {
    name: "account-deletion-cancelled___en",
    path: "/account/deletion-cancelled",
    meta: deletion_45cancelledhQPHqJLL3rPn_Tc_P7Sk6ceXWTzAI2Z2ijXLklRwTOwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/deletion-cancelled.vue")
  },
  {
    name: "account-deletion-cancelled___de",
    path: "/de/account/deletion-cancelled",
    meta: deletion_45cancelledhQPHqJLL3rPn_Tc_P7Sk6ceXWTzAI2Z2ijXLklRwTOwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/deletion-cancelled.vue")
  },
  {
    name: "account-deletion-cancelled___fr",
    path: "/fr/account/deletion-cancelled",
    meta: deletion_45cancelledhQPHqJLL3rPn_Tc_P7Sk6ceXWTzAI2Z2ijXLklRwTOwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/deletion-cancelled.vue")
  },
  {
    name: "account-deletion-cancelled___es",
    path: "/es/account/deletion-cancelled",
    meta: deletion_45cancelledhQPHqJLL3rPn_Tc_P7Sk6ceXWTzAI2Z2ijXLklRwTOwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/deletion-cancelled.vue")
  },
  {
    name: "account-deletion-scheduled___en",
    path: "/account/deletion-scheduled",
    meta: deletion_45scheduled0Ya_Y7XQ_C2QiZ1_45WufcUk40HkkIVrU_wpg4oOzCVDEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/deletion-scheduled.vue")
  },
  {
    name: "account-deletion-scheduled___de",
    path: "/de/account/deletion-scheduled",
    meta: deletion_45scheduled0Ya_Y7XQ_C2QiZ1_45WufcUk40HkkIVrU_wpg4oOzCVDEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/deletion-scheduled.vue")
  },
  {
    name: "account-deletion-scheduled___fr",
    path: "/fr/account/deletion-scheduled",
    meta: deletion_45scheduled0Ya_Y7XQ_C2QiZ1_45WufcUk40HkkIVrU_wpg4oOzCVDEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/deletion-scheduled.vue")
  },
  {
    name: "account-deletion-scheduled___es",
    path: "/es/account/deletion-scheduled",
    meta: deletion_45scheduled0Ya_Y7XQ_C2QiZ1_45WufcUk40HkkIVrU_wpg4oOzCVDEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/deletion-scheduled.vue")
  },
  {
    name: "account-confirm-deletion-code___en",
    path: "/account/confirm-deletion-code",
    meta: confirm_45deletion_45codecuI3wuJq6TOq5iaKhR4Xmu_7mq7jHYTvQihEceWUMy0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/confirm-deletion-code.vue")
  },
  {
    name: "account-confirm-deletion-code___de",
    path: "/de/account/confirm-deletion-code",
    meta: confirm_45deletion_45codecuI3wuJq6TOq5iaKhR4Xmu_7mq7jHYTvQihEceWUMy0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/confirm-deletion-code.vue")
  },
  {
    name: "account-confirm-deletion-code___fr",
    path: "/fr/account/confirm-deletion-code",
    meta: confirm_45deletion_45codecuI3wuJq6TOq5iaKhR4Xmu_7mq7jHYTvQihEceWUMy0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/confirm-deletion-code.vue")
  },
  {
    name: "account-confirm-deletion-code___es",
    path: "/es/account/confirm-deletion-code",
    meta: confirm_45deletion_45codecuI3wuJq6TOq5iaKhR4Xmu_7mq7jHYTvQihEceWUMy0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/confirm-deletion-code.vue")
  },
  {
    name: "groups-groupId-invite-accept",
    path: "/groups/:groupId()/invite/accept",
    meta: accept2zAguSGtR9ZHnywUGTQDIF7BJbbcwttZlzlnIR7EKNIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/groups/[groupId]/invite/accept.vue")
  }
]